import BackIcon from "../../../../assets/images/svgs/BackIcon";
import Close from "../../../../assets/images/svgs/Close";
import styles from "./AuthHeader.module.scss";

interface Props {
  onBackClick?: () => void;
  title: string;
  onClose?: () => void;
}

const AuthHeader = ({ onBackClick, title, onClose }: Props) => {
  return (
    <div className={styles.auth_header}>
      {onBackClick ? (
        <button className={styles.back} onClick={onBackClick}>
          <BackIcon />
        </button>
      ) : null}
      <h2 className={styles.title}>{title}</h2>
      {onClose ? (
        <button className={styles.close} onClick={onClose}>
          <Close />
        </button>
      ) : null}
    </div>
  );
};

export default AuthHeader;
